import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Products } from "@/components/Products";
import { Transformacoes } from "@/components/Transformacoes";
import { CompramosCabelo } from "@/components/CompramosCabelo";
import { NossoEspaco } from "@/components/NossoEspaco";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { initGoogleAds } from "@/lib/googleAds";

export default function App() {
  useEffect(() => {
    initGoogleAds();
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen overflow-x-clip bg-[#0A0A0B] text-[#F9F8F6] antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <Transformacoes />
        <CompramosCabelo />
        <NossoEspaco />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
